module.exports = __webpack_public_path__ + "img/luxury-clinic.838742aa.jpg";